export default "# Private Ownership and Its Problems\n";